export function gospelMeetingBG() {
    // detaches bg to theme entire slideshow (special occasions)
    const html = document.createElement("aside");
    html.classList.add("gospel-meeting-bg");
    html.innerHTML = `
        <style>
            .gospel-meeting-bg {
                font-size: 3vw;
                height: 100vh;
                width: 100vw;
                left: 0;
                top: 0;
                position: absolute;
                box-sizing: border-box;
                overflow: hidden;
                background: #f3dcca url('https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/2024-learning-prayer/slide-bg-mountains.jpg');
                background-size: cover;
                z-index: 0;
            }

            .gospel-meeting-bg::before,
            .gospel-meeting-bg::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
            }

            .gospel-meeting-bg::before {
                background: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, .5));
                opacity: .2;
                z-index: 2;
            }

            .gospel-meeting-bg::after {
                background: linear-gradient(to top, rgba(0, 28, 101, 1) 0%, rgba(0, 28, 101, .75) 37%, rgba(0, 28, 101, 0) 75%);
                opacity: .9;
                mix-blend-mode: multiply;
                z-index: 3;
                height: 100%;
            }

            .gospel-meeting-bg .bg-slant {
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                top: 0;
                z-index: 0;
            }

            .gospel-meeting-bg .bg-slant div {
                height: 100%;
                width: 100%;
                position: absolute;
                transform: translateX(-50%);
                animation-name: move-across;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
            }

            .gospel-meeting-bg .bg-slant div::before {
                content: '';
                display: block;
                background: #0f1f48;
                opacity: .05;
                transform: skew(-45deg, 0);
                height: 100%;
                width: 12em;
                transform-origin: 50% 50%;
            }

            .gospel-meeting-bg .bg-slant div:nth-child(2)::before {
                width: 6em;
            }

            .gospel-meeting-bg .bg-slant div:nth-child(3)::before {
                height: 100%;
                width: auto;
                aspect-ratio: 1 / 1;
                position: absolute;
                top: 75%;
                transform: rotate(45deg);
            }

            .gospel-meeting-bg .bg-slant div:nth-child(1) {
                left: -6em;
                animation-duration: 100s;
            }

            .gospel-meeting-bg .bg-slant div:nth-child(2) {
                left: 2em;
                animation-duration: 80s;
                animation-delay: -50s;
            }

            .gospel-meeting-bg .bg-slant div:nth-child(3) {
                width: 50%;
                left: 15%;
                animation-duration: 120s;
            }

            @keyframes move-across {
                0% {
                    transform: translateX(-25%);
                }

                50% {
                    transform: translateX(100%);
                }

                100% {
                    transform: translateX(-25%);
                }
            }

            .gospel-meeting-bg .man-on-cliff {
                position: absolute;
                right: 76vw;
                top: 0;
                z-index: 1;
                user-select: none;
                height: 100%;
                width: auto;
            }
        </style>
        <img class="man-on-cliff" alt="Person looking over edge of cliff."
            src="https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/2024-learning-prayer/slide-man-on-mountain.png" />
        <div class="bg-slant">
            <div></div>
            <div></div>
            <div></div>
        </div>
    `;
    return html;
}
